import styled from "styled-components";
import { Box, TouchableOpacity } from "./index";
import { themeVariables } from "./../../themes/constants";
import React, { useState, useCallback, useEffect } from "react";

interface IPropsSegment {
  value?: string;
  data?: { title: string; value: any }[];
  onPress?: () => void;
  actived?: boolean;
}

interface IPropsSegmentGroup {
  value?: string;
  defaultValue?: string;
  data: any[];
  onChange?: (val: any) => void;
}

// eslint-disable-next-line react/display-name
const Segment: React.FC<IPropsSegment> = React.memo((props) => {
  const { children, onPress, actived } = props;
  return (
    <TouchableOpacity onPress={onPress}>
      <Item selected={actived}>{children}</Item>
    </TouchableOpacity>
  );
});

export default Segment;

export const SegmentGroup: React.FC<IPropsSegmentGroup> = (props) => {
  const { children, data, onChange = () => {}, value, defaultValue } = props;

  useEffect(() => {
    if (value) {
      setSelectedIndex(data.findIndex((i) => i.value === value));
    }
  }, [data, value]);

  useEffect(() => {
    if (defaultValue && !value) {
      setSelectedIndex(data.findIndex((i) => i.value === defaultValue));
    }
  }, [data, defaultValue, value]);

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleOnpress = useCallback(
    (index) => {
      setSelectedIndex(index);
      onChange(data[index].value);
    },
    [data, onChange]
  );

  return (
    <SegmentContainer display="flex" flex={1} pt={3} pb={1} pl={3}>
      {data.map((item: any, index: number) => (
        <Box
          key={item?.value}
          // width={[1/4, 1/5, 1/6]}
          mr={3}
          mb={2}
        >
          <Segment
            onPress={() => handleOnpress(index)}
            actived={index === selectedIndex}
          >
            {item.title}
          </Segment>
        </Box>
      ))}
    </SegmentContainer>
  );
};

const SegmentContainer = styled(Box)`
  overflow: -moz-scrollbars-none;
  overflow-x: scroll;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
  }
`;

const Item = styled(Box)<{ selected?: boolean }>`
  border-radius: 3px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.primary};
  padding: 6px 8px;

  color: ${(props) =>
    props.selected ? props.theme.colors.white : props.theme.colors.primary};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.white};
  width: fit-content;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  transition: color 0.2s ease;
`;
